module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get.a018e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_lets-get.png
// module id = 03GC
// module chunks = 0